<template>
  <v-row>
    <v-col cols="12" class="mt-0 mb-1 pb-0 pt-2">
      <v-dialog
        ref="dialog"
        v-model="show_dialogue"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            clearable
            class="flex-md-grow-1"
            dense
            outlined
            filled
            autocomplete="off"
            :label="label"
            :prepend-inner-icon="icon"
            :disabled="disabled"
            v-model="date"
            :rules="validation_rules"
            :required="required"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="show_dialogue = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DateField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-calendar",
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    format:{
        type: String,
        default: "YYYY-MM-DD"
    },
  },
  data: () => {
    return {
      show_dialogue: false,
    };
  },
  computed: {
    date: {
      get() {
        if (
          typeof this.value == "undefined" ||
          this.value == undefined ||
          this.value == null ||
          this.value.toString().trim() == ""
        ) {
          return new Date().toISOString().substr(0, 10);
        }
        return this.value;
      },
      set(new_value) {
        this.$emit("input", new_value);
      },
    },
  },
};
</script>